import { z } from 'zod';

export const CloudMovements = [
  'N',
  'NE',
  'E',
  'SE',
  'S',
  'SW',
  'W',
  'NW',
  'UNKNOWN',
  'OBSCURED',
  'VERTICAL',
] as const;
export const CloudMovementZod = z.enum(CloudMovements);
export type CloudMovement = z.infer<typeof CloudMovementZod>;

export const CloudMovementText: Record<CloudMovement, string> = {
  N: 'North',
  NE: 'Northeast',
  E: 'East',
  SE: 'Southeast',
  S: 'South',
  SW: 'Southwest',
  W: 'West',
  NW: 'Northwest',
  UNKNOWN: 'Unknown',
  OBSCURED: 'Obscured',
  VERTICAL: 'Vertical',
};

export const CloudMovementTacText: Record<CloudMovement, string> = {
  N: 'N',
  NE: 'NE',
  E: 'E',
  SE: 'SE',
  S: 'S',
  SW: 'SW',
  W: 'W',
  NW: 'NW',
  UNKNOWN: 'UNKNOWN',
  OBSCURED: 'OBSCD',
  VERTICAL: 'VERTICAL',
};
